<template>
  <div class="py-1">
    <MenuOption
      v-if="activeMappingTab !== 'customers'"
      id="create-test-items"
      :title="$t('area.business-central.item-mapping.dev-tools.create-test-items')"
      @select="onCreateTestItemsSelect">
      <template #icon>
        <div class="flex items-center gap-1.5">
          <DevBadge />
          <IconLucidePackagePlus class="h-4 w-4" />
        </div>
      </template>
    </MenuOption>
    <MenuOption
      v-else
      id="create-test-customer"
      :title="$t('area.business-central.customer-mapping.dev-tools.create-test-customer')"
      @select="onCreateTestCustomersSelect">
      <template #icon>
        <div class="flex items-center gap-1.5">
          <DevBadge />
          <IconLucideUserPlus class="h-4 w-4" />
        </div>
      </template>
    </MenuOption>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'

export default {
  name: 'BcDevToolsMenu',

  emits: ['close'],

  props: {
    activeMappingTab: { type: String, required: true },
    onOpenCreateTestItems: { type: Function as PropType<() => void>, required: true },
    onOpenCreateTestCustomers: { type: Function as PropType<() => void>, required: true },
  },

  methods: {
    onCreateTestItemsSelect(): void {
      this.onOpenCreateTestItems()
      this.$emit('close')
    },

    onCreateTestCustomersSelect(): void {
      this.onOpenCreateTestCustomers()
      this.$emit('close')
    },
  },
}
</script>
